<template>
	<transition name="modal-fade">
		<div class="overlay" @click.self="$emit('close')">
			<div class="card-appearance modal open" :class="classes">
				<button aria-label="Close" class="modal__exit" @click.prevent.stop="$emit('close')">
					<img src="/imgs/icons/icon_close.svg" alt="exit modal" />
				</button>

				<h2 class="heading-3-bold mb-32">
					<slot name="title"></slot>
				</h2>

				<slot name="header"></slot>

				<div class="main modal-main-content">
					<slot name="body"></slot>
				</div>

				<div v-if="this.$slots.footer">
					<div class="modal__buttons mt-32">
						<slot name="footer"></slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "Modal",
	props: {
		classes: {
			type: String,
			default: "modal-w-860",
		},
	},
	mounted() {
        document.body.style.overflow = "hidden";
    },
    beforeDestroy() {
        document.body.style.overflow = "auto";
    }
};
</script>

<style lang="scss">
.modal-fade-enter,
.modal-fade-leave-active {
	opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
	transition: opacity 0.5s ease;
}

.modal-w-860 {
	max-width: 860px;
	width: 100%;
}

.modal-main-content {
	max-height: 400px !important;
}

.modal {
	margin: auto;
	padding: 24px 0;
	display: grid;
	grid-template-rows: auto 1fr auto;
	color: #646464;
	font-weight: 500;
	position: relative;
	transform: scale(0);
	transition: transform 0.3s ease-in-out;
	line-height: normal !important;

	&.open {
		transform: scale(1);
	}

	> *:not(.main):not(.modal__exit) {
		padding-left: 32px;
		padding-right: 32px;
	}

	h2 {
		text-align: center !important;
	}

	&__exit {
		position: absolute;
		top: 15px;
		right: 15px;

		img {
			width: 15px;
		}
	}

	.main {
		display: grid;
		grid-template-columns: 1fr 32px;
		overflow-y: auto;
		padding-left: 32px;
	}

	&__buttons {
        margin-bottom: -16px;

        &__button {
            margin-bottom: 16px;
            width: 100%;
        }

        @media (min-width: 480px) {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            flex-wrap: wrap;
            margin-right: -24px;

            &__button {
                margin-right: 24px;
                width: auto;
                padding: 0 20px;
            }
        }
	}

	.hline {
		margin: 24px -32px 24px -32px;
		border-bottom: 2px solid #eaf2f4;
	}
}
</style>
